import React, { Fragment } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { Text } from 'components/Text';
import './DealOrderInModal.scss';
/**
 * @component DealCancelOrderModal
 * @since 1.0.0
 * @hidden
 */
export function DealCancelOrderModal(props) {
    const { onClose, onConfirm } = props;
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-order-in-modal-button-container" },
            React.createElement(Button, { style: "primary", label: t('Yes'), onPress: onConfirm }))));
    return (React.createElement("div", { className: "deal-order-in-modal" },
        React.createElement(Modal, { picto: "file-xmark", title: t('Cancel order'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-order-in-modal-content" },
                React.createElement(Text, { value: t('Are you sure to cancel this order?') })))));
}
